module.exports = __webpack_public_path__ + "img/Insurance.825f5b5c.png";